import { createResourceApi } from 'resources/ResourceApi';
import { LocationApiItem } from 'typings/api';

export default createResourceApi<LocationApiItem>('locations');
